import React from "react";
import g from "glamorous";

const Div = g.div({
  backgroundColor: `#3c4d68`,
  color: `white`,
  padding: `1em`,
  borderRadius: `6px`,
  display: `flex`,
  flexDirection: `column`,
  alignItems: `stretch`,
});

const Title = g.h4({
  margin: `0 auto .35em`,
  letterSpacing: `0.06em`,
  fontSize: `1.2em`,
});

const Text = g.p({
  fontSize: `.85em`,
  lineHeight: `1.35em`,
});

const Input = g.input({
  backgroundColor: `#3c4d68`,
  color: `white`,
  width: "99%",
  border: `none`,
  borderBottom: `2px solid white`,
  fontSize: `.85em`,
  marginBottom: `.5em`,
  transition: `all .3s`,
  ":focus": {
    letterSpacing: `.02em`,
    outline: `none`,
    transition: `all .3s`,
  },
});

const InputHidden = g.input({
  display: `none`,
});

const Textarea = g.textarea({
  backgroundColor: `#3c4d68`,
  color: `white`,
  width: "98%",
  border: `.12em solid white`,
  margin: `.8em 0 .5em`,
  fontSize: `.85em`,
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'`,
  ":focus": {
    letterSpacing: `.02em`,
    outline: `none`,
    transition: `all .3s`,
  },
});

const Button = g.input({
  backgroundColor: `white`,
  border: `2px solid white`,
  color: `#3c4d68`,
  borderRadius: `5px`,
  marginTop: `.8em`,
  marginLeft: `auto`,
  padding: `.3em .7em .45em`,
  fontSize: `.8em`,
  fontWeight: `bold`,
  transition: `all .3s`,
  ":hover": {
    color: `white`,
    backgroundColor: `#3c4d68`,
    transition: `all .3s`,
  },
  ":focus": {
    outline: `none`,
    color: `white`,
    backgroundColor: `#3c4d68`,
    transition: `all .3s`,
  },
});

export default ({ ...props }) => (
  <Div>
    <Title>Renseignements</Title>
    <Text>
      Pour toute demande d'informations
      {props.about && <span> concernant {props.about}</span>}, n'hésitez pas à
      nous laisser vos coordonnées.
    </Text>
    <form action="https://formspree.io/f/mqkgdqrq" method="POST">
      <Input
        type="text"
        id="coordonnees"
        placeholder="Votre email ou n° de téléphone"
        name="Coordonnees"
        aria-label="Votre email ou n° de téléphone"
        onKeyPress={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      />
      <Input
        type="textarea"
        id="intervention"
        placeholder="L'intervention qui vous intéresse"
        name="Intervention"
        aria-label="L'intervention qui vous intéresse"
        onKeyPress={(e) => {
          if (e.key === "Enter") e.preventDefault();
        }}
      />
      <Textarea
        type="textarea"
        id="message"
        placeholder="Votre message"
        name="Message"
        aria-label="Votre message"
        css={{
          height: `130px`,
          padding: `.5em`,
          width: `94%`,
          borderRadius: `6px`,
        }}
        wrap="hard"
      />
      <InputHidden
        type="textarea"
        id="page"
        value={props.about}
        name="Page"
        aria-label="Page du site consultée"
      />
      <input type="hidden" name="_language" value="fr" />
      <g.Div display={`flex`} justifyContent={`space-between`}>
        <Button type="submit" value="Envoyer" />
      </g.Div>
    </form>
  </Div>
);
